module.exports = __webpack_public_path__ + "static/family_low-fe9332890628378c456b4068eceebb73.mp4";